import { Producer } from 'types/producer'

export type ProducerCardProps = {
  active?: boolean
  className?: string
  hideButton?: boolean
  hideDescription?: boolean
  onButtonClick?: () => void
  onMouseEnter?: (producer: Producer) => void
  onMouseLeave?: () => void
  producer: Producer
}

// Enums

export enum ProducerStatus {
  ALMOST_SOLD_OUT = 'almostSoldOut',
  POPULAR = 'popular',
  RESERVED = 'reserved',
  SOLD_OUT = 'soldOut'
}
